var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import dayjs from 'dayjs';
import fetchTtvBuffer from '@tving/utils/src/apis/ttvBuffer/fetchTtvBuffer';
import fetchVersion from '@tving/utils/src/apis/version/fetchVersion';
import { CACHE_KEY } from '@tving/utils/src/constants/commonConstants';
import proxyTtvBuffer from '@tving/utils/src/proxies/ttvBuffer/proxyTtvBuffer';
import proxyVersion from '@tving/utils/src/proxies/version/proxyVersion';
import getDeviceType from '@tving/utils/src/utils/common/getDeviceType/getDeviceType';
/**
 * 진입 시 ttv, buffer 등 필요한 확인절차를 통해 redirect 해야할 경로를 만들어냅니다.
 *
 */
var generateEntry = function () { return __awaiter(void 0, void 0, Promise, function () {
    var tvingVersion, _a, entryData, _b, isTtvOn, isBufferOn, bufferUrl, _c, url, bufferCache, isCheckedYn, timestamp, bufferCacheDate, bufferCacheHour, date, hour, isExpired, search, isUrlFromBuffer, splitRedirect, mediaCode;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = proxyVersion;
                return [4 /*yield*/, fetchVersion()];
            case 1:
                tvingVersion = _a.apply(void 0, [_d.sent()]);
                entryData = {
                    lastUpdateDate: tvingVersion.lastUpdateDate,
                };
                _c = proxyTtvBuffer;
                return [4 /*yield*/, fetchTtvBuffer({ poc: 'tv' })];
            case 2:
                _b = _c.apply(void 0, [_d.sent()]), isTtvOn = _b.isTtvOn, isBufferOn = _b.isBufferOn, bufferUrl = _b.bufferUrl;
                if (isTtvOn) {
                    // TTV 레이어에서 위 cacheQuery 통해 값 얻기!
                    return [2 /*return*/, __assign(__assign({}, entryData), { redirectUrl: '/ttv', isSkipSplash: true })];
                }
                // buffer
                if (isBufferOn) {
                    url = "".concat(bufferUrl + (bufferUrl.indexOf('?') === -1 ? '?' : '&'), "from=").concat(getDeviceType().toLowerCase(), "&appName=legacy");
                    bufferCache = JSON.parse(sessionStorage.getItem(CACHE_KEY.BUFFER));
                    if (!bufferCache) {
                        return [2 /*return*/, __assign(__assign({}, entryData), { isHref: true, isSkipSplash: true, redirectUrl: url.toString() })];
                    }
                    isCheckedYn = bufferCache.isCheckedYn, timestamp = bufferCache.timestamp;
                    bufferCacheDate = timestamp ? dayjs(timestamp).format('DD') : '';
                    bufferCacheHour = timestamp ? dayjs(timestamp).format('HH') : '';
                    date = dayjs(Date.now()).format('DD');
                    hour = dayjs(Date.now()).format('HH');
                    isExpired = bufferCacheDate !== date || parseInt(hour, 10) - parseInt(bufferCacheHour, 10) > 1;
                    if (isCheckedYn !== 'Y' && isExpired) {
                        // 버퍼 체크 안됐거나, 체크 시간이 만료된 경우 버퍼 페이지 이동
                        return [2 /*return*/, __assign(__assign({}, entryData), { isHref: true, isSkipSplash: true, redirectUrl: url.toString() })];
                    }
                    search = window.location.search;
                    if (search) {
                        isUrlFromBuffer = (search === null || search === void 0 ? void 0 : search.indexOf('buffer=Y')) > -1;
                        if (isUrlFromBuffer) {
                            splitRedirect = search === null || search === void 0 ? void 0 : search.split('redirect=');
                            if (splitRedirect && splitRedirect[1]) {
                                return [2 /*return*/, __assign(__assign({}, entryData), { redirectUrl: splitRedirect[1] })];
                            }
                        }
                    }
                }
                if (tvingVersion.isUpdated) {
                    return [2 /*return*/, __assign(__assign({}, entryData), { isUpdated: true })];
                }
                // LG deeplink 대응 (http://smarttv.tving.com/?titleid=$CONTENTID)
                if (window.location.search.indexOf('titleid=') > -1) {
                    mediaCode = window.location.search.split('titleid=')[1];
                    if (mediaCode === 'PROFILES') {
                        return [2 /*return*/, __assign(__assign({}, entryData), { redirectUrl: "/profile" })];
                    }
                    return [2 /*return*/, __assign(__assign({}, entryData), { redirectUrl: "/detail/".concat(mediaCode) })];
                }
                return [2 /*return*/, entryData];
        }
    });
}); };
export default generateEntry;
